import Vue from 'vue'
import Vuex from 'vuex'

import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VTooltip from 'v-tooltip'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faSpinner,
  faChevronUp,
  faInfoCircle,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import '@services/axiosDefaults'

// Подключаем трекер ошибок только для продакшн-сборки проекта
if (process.env.NODE_ENV === 'production') {
  const VERSION = '1.2.0'

  Sentry.init({
    Vue,
    dsn: 'https://6f2ab4d68f6a48f58cd7d26171d68788@o530818.ingest.sentry.io/5650643',
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1,
    release: VERSION,
  })
}

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VTooltip)
Vue.use(VueToast, {
  position: 'top',
})
Vue.use(Vuex)
library.add(faSpinner, faChevronUp, faInfoCircle, faTriangleExclamation)
Vue.component('font-awesome-icon', FontAwesomeIcon)
